var map = {
	"./icon-arrow-slider-left.svg": 2091,
	"./icon-arrow-slider-right.svg": 2092,
	"./icon-calendar-blue.svg": 1781,
	"./icon-cart.svg": 2093,
	"./icon-close-blue.svg": 2094,
	"./icon-close-popup.svg": 2095,
	"./icon-constant-blue.svg": 2096,
	"./icon-current-location.svg": 2097,
	"./icon-down-red.svg": 2098,
	"./icon-email-blue.svg": 257,
	"./icon-eye.svg": 2099,
	"./icon-filter.svg": 1778,
	"./icon-home.svg": 2100,
	"./icon-info-blue.svg": 2101,
	"./icon-instagram-blue.svg": 1782,
	"./icon-instagram-dark.svg": 2102,
	"./icon-instagram-outline-main.svg": 2103,
	"./icon-instagram.svg": 2104,
	"./icon-line.svg": 2105,
	"./icon-logout.svg": 2106,
	"./icon-mobile-phone.svg": 340,
	"./icon-phone-outline.svg": 2107,
	"./icon-phone.svg": 341,
	"./icon-preorder.svg": 2108,
	"./icon-share-facebook.svg": 2109,
	"./icon-share-line.svg": 2110,
	"./icon-share-link.svg": 1784,
	"./icon-share-profile.svg": 2111,
	"./icon-share-twitter.svg": 2112,
	"./icon-share.svg": 2113,
	"./icon-tiktok-blue.svg": 2114,
	"./icon-tiktok-dark.svg": 2115,
	"./icon-time.svg": 2116,
	"./icon-twitter-x-dark.svg": 2117,
	"./icon-up-green.svg": 2118,
	"./icon-whatsapp-blue.svg": 1783,
	"./icon-whatsapp-outline.svg": 894,
	"./icon-whatsapp.svg": 2119,
	"./icon-wishlist-2.svg": 1779,
	"./icon-wishlist-filled-2.svg": 1780,
	"./icon-wishlist-filled.svg": 2120,
	"./icon-wishlist.svg": 2121,
	"./icon-youtube-dark.svg": 2122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1826;